import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { AuthProvider } from "./auth/AuthProvider";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { MainApp } from "./components/MainApp";

interface Props {
  instance: PublicClientApplication;
}

const App = ({ instance }: Props) => (
  <MsalProvider instance={instance}>
    <AuthProvider>
      <ProtectedRoute>
        <MainApp />
      </ProtectedRoute>
    </AuthProvider>
  </MsalProvider>
);

export default App;
